<div class="table-header" [class.table-header--fixed]="isFixed()">
	<ng-content />
</div>